import React from 'react';

import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import FirstInInboxPng from './images/first-in-inbox.png';
import FirstInInboxWebp from './images/first-in-inbox.webp';
import Arrows from './images/arrows-pointing-inward.svg';
import { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { useGetHasProduct } from '../../../../../customHooks/useGetHasProduct.hook';
import { ProductType } from '../../../../../@types/product';
import { Msg, useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewTab: { maxWidth: 530 },
};

const OverviewTab = () => {
  const { t } = useIntl();
  const isEntitledPlusRent = useGetHasProduct(ProductType.MieterPlus);

  return (
    <div style={styles.overviewTab}>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        {t({
          id: 'benefits.firstInInboxMieterPlus.modal.overview',
          defaultMessage: 'Your messages sent to the offering person...',
        })}
      </div>
      {!isEntitledPlusRent && (
        <ul className='list-check list-spacing-s'>
          <li data-testid='mieter-plus-label-with-checkmark'>
            <Msg
              id='benefits.firstInInboxMieterPlus.modal.activeMieterPlus'
              defaultMessage='Keep Mieter Plus...'
              values={{
                MieterPlusLogo: <PlusBadge variant='rent' />,
              }}
            />
          </li>
        </ul>
      )}
    </div>
  );
};

const ButtonArea = () => {
  return (
    <div className='align-center'>
      <a
        className='button-secondary button-rounded'
        href='/meinkonto/premium-mitgliedschaft/?cmp_id=10-051527&cmp_name=residential_profile&cmp_position=residential_benefits&cmp_creative=contact_at_top_cta'
      >
        <Msg id='benefits.firstInInboxMieterPlus.modal.linkButton' defaultMessage='Discover Mieter Plus' />
      </a>
    </div>
  );
};

export const FirstInInboxMieterPlus = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();
  const isEntitledPlusRent = useGetHasProduct(ProductType.MieterPlus);

  return (
    <Modal
      title={t({ id: 'benefits.firstInInboxMieterPlus.headline', defaultMessage: 'First in inbox' })}
      isVisible={isVisible}
      image={FirstInInboxPng}
      imageWebp={FirstInInboxWebp}
      imageAlt={t({
        id: 'benefits.firstInInboxMieterPlus.modal.image',
        defaultMessage: 'Smartphone display showing vendors list',
      })}
      imageBackgroundStyles={{
        '@media (min-width: 669px)': {
          backgroundImage: `url(${Arrows})`,
          backgroundSize: 'auto 280px',
          backgroundPosition: 'center bottom, 55% center',
        },
      }}
      imageUseFullWidth={false}
      tabsContent={[<OverviewTab key='benefits.firstInInboxMieterPlus.modal.overview' />]}
      benefit={Benefit.MESSENGER}
      buttonArea={!isEntitledPlusRent ? <ButtonArea /> : null}
      onClose={onClose}
    />
  );
};
